import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const PaymentEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [formData, setFormData] = useState({});

    useEffect(() => {
        fetchData('CautionRefundApi', `/PaymentEdit/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Customer Details:', error);
            });
    }, [id]);




    const submitData = async (e) => {
        setIsLoading(true);


        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
        }));

        const createData = {
            Id : formData.Id,
            CompanyId: companyId,
            BillNo : formData.BillNo,
            BillDate: formData.BillDate,
            CustomerId: formData.CustomerId,
            RoomId: formData.RoomId,
            PaymentType: formData.PaymentType,
            CautionDeposut: formData.CautionDeposut,
            CleaningCharge: formData.CleaningCharge,
            OtherCharge: formData.OtherCharge,
            RefundAmount : (formData.CautionDeposut)-(formData.CleaningCharge)-(formData.OtherCharge),
            Remarks : formData.Remarks,
            CreatedBy : formData.CreatedBy,
            CreatedDate : formData.CreatedDate,
            UpdatedBy : userId,
            IsActive : formData.IsActive,
        };

        updateData('CautionRefundApi', `${id}`, createData, token)
            .then((response) => {
                setSuccessMessage('Refund Updated successfully!');
                setErrorMessage('');

                history.push('/PaymentIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);

            })
            .catch((error) => {
                console.error('Refund Create error:', error);
                setIsLoading(false);
            });

    };


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));

        if (name === 'PaymentType') {
            setSelectedPaymentType(value);
        }

    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };


    return (
        <Fragment>

            <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '900px', overflow: 'auto' }}>
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                        
                        
                    `}
                </style>


                <div>

                    <div className='w-full flex' style={{ marginTop: '10px' }}>
                        <h6 className="productHead flex-grow linkcolorBlack" style={{ fontFamily: 'Times new romans', fontWeight: 'bolder' }}>RENT RECEIPT EDIT</h6>
                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/PaymentIndex"
                            className="linkcolor"
                            style={{
                                marginRight: '8px',
                                background: 'linear-gradient(to right, darkred, slategray)',
                                borderRadius: '50px',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                height: '30px'
                            }}

                        >
                            BACK
                        </Button>

                        <Button
                            variant="contained"
                            style={{
                                marginRight: '8px',
                                background: 'linear-gradient(to right, darkgreen, slategray)',
                                borderRadius: '50px',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                height: '30px'
                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                        </Button>

                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-2 flex flex-wrap">
                        <div className="w-full sm:w-3/5 pr-2 mb-2 sm:mb-0"> {/* Adjusted width for smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="customer">
                                Customer
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.customername}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter CustomerName"
                                name='customername'
                                disabled
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Reference Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                type="date"
                                placeholder="Enter Reference Date"
                                name='BillDate'
                                onChange={handleChange}
                            />
                        </div>
                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Reference No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.BillNo}
                                type="text"
                                placeholder="Enter Reference No"
                                readOnly
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-2 flex flex-wrap">
                        <div className="w-full sm:w-3/5 pr-2 mb-2 sm:mb-0">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="rate">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Remarks}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Remarks"
                                name='Remarks'
                            />
                        </div>


                        <div className="w-full sm:w-1/5 pl-2 sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.CautionDeposut !== undefined ? parseFloat(formData.CautionDeposut).toFixed(2) : 0}
                                type="text"
                                placeholder="Enter Amount"
                                onChange={handleChange}
                                name='CautionDeposut'
                                disabled
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2  sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Cleaning Charge
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.CleaningCharge}
                                onChange={handleChange}
                                type="text"
                                placeholder="Cleaning Charge"
                                name='CleaningCharge'
                                style={{ textAlign: 'right' }}
                            />

                        </div>

                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Other Charge
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.OtherCharge}
                                onChange={handleChange}
                                type="text"
                                placeholder="OtherCharge"
                                name='OtherCharge'
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2  sm:block">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Refund Amount
                                <span className="text-red-500">*</span>
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                //value={(formData.RefundAmount)}
                                value={(formData.CautionDeposut) - (formData.CleaningCharge) - (formData.OtherCharge)}
                                type="text"
                                placeholder="Enter Amount"
                                onChange={handleChange}
                                name='RefundAmount'
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2">
                                Payment Type
                            </label>
                            <div className="flex items-center">
                                <label className="block  tracking-wide text-gray-700  font-bold mr-2">
                                    <input type="radio" name="PaymentType" value="1"
                                        checked={formData.PaymentType === 1 || formData.PaymentType === "1"}
                                        onChange={handleChange} />
                                    Cash
                                </label>
                                <label className="block  tracking-wide text-gray-700  font-bold mr-2">
                                    <input type="radio" name="PaymentType" value="2"
                                        checked={formData.PaymentType === 2 || formData.PaymentType === "2"}
                                        onChange={handleChange} />
                                    Cheque
                                </label>
                                <label className='block  tracking-wide text-gray-700  font-bold'>
                                    <input type="radio" name="PaymentType" value="3"
                                        checked={formData.PaymentType === 3 || formData.PaymentType === "3"}
                                        onChange={handleChange} />
                                    UPI
                                </label>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </Fragment >
    );
}

export default PaymentEdit;
